import React from "react";
import { motion } from "framer-motion";
import { classes } from "./tokens";

/**
 * Payment Methods strip — subtle India-first conversion booster.
 * Shows we accept everything Indian customers actually use, kills the
 * "they won't take UPI" objection at the LP level. Uses pure CSS plates
 * (no external image deps).
 */
const methods = [
  { name: "UPI",         color: "#5F259F", initial: "U₹" },
  { name: "PhonePe",     color: "#5F259F", initial: "Pe" },
  { name: "Google Pay",  color: "#4285F4", initial: "G" },
  { name: "Paytm",       color: "#00BAF2", initial: "P" },
  { name: "Visa",        color: "#1A1F71", initial: "V" },
  { name: "Mastercard",  color: "#EB001B", initial: "M" },
  { name: "Net Banking", color: "#0F172A", initial: "NB" },
  { name: "EMI",         color: "#16A34A", initial: "EMI" },
  { name: "Cash",        color: "#475569", initial: "₹" },
];

const CarServicePaymentStrip = () => (
  <section
    className="py-10 lg:py-14 bg-white border-y border-slate-100"
    data-testid="payment-strip-section"
  >
    <div className={classes.container}>
      <div className="flex flex-col lg:flex-row lg:items-center gap-5 lg:gap-10">
        <div className="lg:w-[260px] shrink-0">
          <div className="text-[10px] font-extrabold uppercase tracking-[0.22em] text-blue-600 mb-1.5">
            Pay your way
          </div>
          <h3 className="text-base lg:text-lg font-extrabold text-slate-900 leading-tight">
            All Indian payment methods accepted.
            <span className="block text-slate-500 font-bold mt-1 text-sm">
              Sirf service ke baad pay karein.
            </span>
          </h3>
        </div>

        <div className="flex-1 flex flex-wrap items-center gap-2 lg:gap-3">
          {methods.map((m, i) => (
            <motion.div
              key={m.name}
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.3, delay: i * 0.04 }}
              className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-slate-50 border border-slate-200 hover:border-slate-300 hover:bg-white transition-all"
            >
              <span
                className="w-7 h-7 rounded-md inline-flex items-center justify-center text-white font-extrabold text-[11px]"
                style={{ backgroundColor: m.color }}
              >
                {m.initial}
              </span>
              <span className="text-xs sm:text-sm font-bold text-slate-700 whitespace-nowrap">
                {m.name}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default CarServicePaymentStrip;
